// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"268":"Home","786":"TermsOfService"}[chunkId] || chunkId) + "." + {"21":"ab168712","268":"b8e4e0dd","519":"bf193247","655":"a5824bb8","786":"f1340080"}[chunkId] + ".chunk.js";
};